import { UploadDataBox } from "./UploadDataBox";

export const InvoiceManageUpload = () => {

    return (
        <>
            <UploadDataBox />
        </>
    )
}